export default "__VITE_ASSET__M9djoO4K__"